import { BaseService } from './base';
import { ServiceForm } from '../models/serviceForm';

/**
 * Stub service for ServiceForm model registration.
 * CRUD operations are managed through ServiceService
 * (addForm, updateForm, removeForm).
 */
export class ServiceFormService extends BaseService<ServiceForm> {
  override model = ServiceForm;
  override modelName = 'serviceForm';
  override modelLabel = 'Service Form';
}